import axios from "axios";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MessageToster from "../component/MessageToster";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import { getAuthToken, useHandleUnauthorized } from "../token";
import { BASE_URL } from "../api";
import Loader from "../component/Loader";
import { getApiHeaders } from "../utils/helpers";
import { useHandleError } from "../hooks/useHandleError";


export default function MasterPassword() {
    const navigate = useNavigate();
    const { search } = useLocation();
    const handleError = useHandleError();
    const mid = sessionStorage.getItem("mid");

    const queryParams = new URLSearchParams(search);
    const accountNumber = queryParams.get("account");
    const type = queryParams.get("type");
    const accountType = type ? type.toUpperCase() : "";

    const handleBack = () => {
        if (type === "demo") {
            navigate("/demo_account");
        } else if (type === "live") {
            navigate("/demo_account");
        } else if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate("/dashboard");
        }
    };
    const token = getAuthToken();
    const handleUnauthorized = useHandleUnauthorized();

    const [loading, setLoading] = useState(false);
    const [verror, setVerror] = useState('');
    const [verified, setVerified] = useState(false);
    const [showMasterPass, setShowMasterPass] = useState(false);
    const [showPass, setShowPass] = useState({
        new_password: false,
        confirm_password: false
    })

    // FOR FORGOT MASTER PASSWORD FLOW
    const [showForgot, setShowForgot] = useState(false);
    const [fpInput, setFpInput] = useState({ email: "" });
    const [fpError, setFpError] = useState("");
    const [fpValidation, setFpValidation] = useState(false);

    // OTP
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState("");
    const [otpError, setOtpError] = useState("");

    const [isForgotFlow, setIsForgotFlow] = useState(false);
    const [forgotEmail, setForgotEmail] = useState("");


    const [pass, setPass] = useState({
        old_password: "",
        new_password: "",
        conform_password: ""
    });

    const [passvalidations, setPassValidations] = useState({
        old_password: false,
        new_password: false,
        conform_password: false
    });

    const passhandelchange = (e) => {
        const { name, value } = e.target;
        setPass({ ...pass, [name]: value });
        setPassValidations({ ...passvalidations, [name]: false });
        setVerror('');
    };

    const validationRules = {
        old_password: "Old Password is required.",
        new_password: "New Password is required.",
        conform_password: "Confirm Password is required."
    };

    const submitForgotPassword = async (e) => {
        e.preventDefault();

        if (!fpInput.email) {
            setFpValidation(true);
            setFpError("Email is required");
            return;
        }

        setLoading(true);

        try {
            const inputBody = { email: fpInput.email };

            const res = await axios.post(`${BASE_URL}/MT5M/mt5_master_password_forgot?email=${fpInput.email}`, inputBody);

            if (res.data.code === 200) {
                MessageToster("success", res.data.message);

                setOtpSent(true);
                setIsForgotFlow(true);
                setShowForgot(false);

                setForgotEmail(fpInput.email);
            } else {
                MessageToster("error", res.data.message);
            }
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    };

    const verifyOldPassword = async () => {
        if (!pass.old_password) {
            setPassValidations({ ...passvalidations, old_password: true });
            setVerror(validationRules.old_password);
            return;
        }

        if (!token) {
            handleUnauthorized();
            return;
        }

        setLoading(true)

        try {

            let apiUrl = "";

            if (type === "live") {
                apiUrl = `${BASE_URL}/MT5/check_investor_master_password_live_account`;
            } else {
                apiUrl = `${BASE_URL}/MT5/check_investor_master_password_demo_account`;
            };

            const checkBody = {
                mid: Number(mid),
                account_number: Number(accountNumber),
                password_type: Number(0),
                password: pass.old_password
            };

            // const checkBody = {
            //     user_login: Number(accountNumber),
            //     password_type: "0",
            //     master_password: pass.old_password
            // };

            const checkRes = await axios.post(apiUrl, checkBody, { headers: getApiHeaders() });

            // setLoading(false);

            if (checkRes.data.code === 200) {
                setVerified(true);
                MessageToster("success", "Old password verified. You can set a new password now.");
            } else {
                MessageToster("error", checkRes.data.message || "Old password is incorrect.");
                console.log("-dasdasjdhw", checkRes.data.message);

            }
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    }

    const ChangePassword = async (e) => {
        e.preventDefault();

        if (isForgotFlow) {
            if (!otp) {
                MessageToster("error", "OTP is required");
                return;
            }

            if (otp.length !== 6) {
                MessageToster("error", "OTP must be 6 digits");
                return;
            }

            if (!/^[0-9]+$/.test(otp)) {
                MessageToster("error", "OTP must contain only numbers");
                return;
            }
        }

        for (const field of ["new_password", "conform_password"]) {
            if (!pass[field]) {
                setPassValidations({ ...passvalidations, [field]: true });
                setVerror(validationRules[field]);
                return;
            }
        }
        if (pass.new_password !== pass.conform_password) {
            setPassValidations({ ...passvalidations, conform_password: true });
            setVerror("New Password and Confirm Password do not match.");
            return;
        }

        if (!token) {
            handleUnauthorized();
            return;
        }
        setLoading(true);

        try {

            const changeBody = {
                mid: Number(mid),
                account_number: accountNumber,
                // account_number: Number(accountNumber),
                account_type: accountType,
                password_type: 0,
                master_password: pass.new_password,
                is_forgot: isForgotFlow ? 1 : 0,
                email: isForgotFlow ? forgotEmail : "",
                verifycode: isForgotFlow ? otp : 0,
            };

            const changeRes = await axios.post(`${BASE_URL}/MT5M/new_user_real_account_master_n_investor_password_change`, changeBody, { headers: getApiHeaders() });

            setLoading(false);

            if (changeRes.data.code === 200) {
                MessageToster("success", changeRes.data.message);
                setPass({ old_password: "", new_password: "", conform_password: "" });
                setVerified(false);
                navigate("/dashboard");
            } else {
                MessageToster("error", changeRes.data.message);
            }
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div id="layout-wrapper">
            {loading &&
                <Loader />
            }
            <Topbar />
            <Sidebar />
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row mb-3">
                            <div className="col-12">
                                <div className="page-title-box d-flex flex-wrap align-items-center justify-content-between gap-2 pb-0">
                                    <div>
                                        <h2 className="fw-700 mb-1">Trading Password</h2>
                                        <p className="text-muted mb-0 font-size-13">
                                            Change the trading password for account:{" "}
                                            <span className="badge bg-primary-subtle text-primary font-size-12 px-2 py-0.5">
                                                #{accountNumber} {accountType ? `(${accountType})` : ""}
                                            </span>
                                        </p>
                                    </div>
                                    <div>
                                        <button
                                            type="button"
                                            className="btn btn-primary gap-2 waves-effect d-inline-flex align-items-center gap-1.5 px-3 py-1.5 shadow-sm"
                                            onClick={handleBack}
                                            style={{ borderRadius: "8px", fontWeight: "500" }}
                                        >
                                            <i className="mdi mdi-arrow-left font-size-16"></i>
                                            <span>Back</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row justify-content-start">
                            <div className="col-12 col-md-10 col-lg-7 col-xl-6">
                                <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "14px", overflow: "hidden" }}>
                                    <div
                                        className="card-header bg-transparent border-bottom px-4 py-3 d-flex align-items-center justify-content-between"
                                        style={{ borderColor: "var(--bs-border-color)" }}
                                    >
                                        <div className="d-flex align-items-center gap-2">
                                            <div
                                                className="avatar-xs d-flex align-items-center justify-content-center bg-primary-subtle text-primary rounded-circle"
                                                style={{ width: "36px", height: "36px" }}
                                            >
                                                <i className="mdi mdi-shield-key-outline font-size-18"></i>
                                            </div>
                                            <div>
                                                <h5 className="mb-0 fw-bold font-size-15 text-dark">
                                                    {verified
                                                        ? "Set New Trading Password"
                                                        : showForgot
                                                            ? "Forgot Trading Password"
                                                            : isForgotFlow
                                                                ? "Verify OTP & Reset Password"
                                                                : "Trading Password Verification"}
                                                </h5>
                                                <p className="text-muted mb-0 font-size-12">
                                                    {verified
                                                        ? "Create and confirm your new trading password"
                                                        : showForgot
                                                            ? "Enter your registered email to receive OTP"
                                                            : isForgotFlow
                                                                ? "Enter the OTP received on your email"
                                                                : "Enter your current trading password to proceed"}
                                                </p>
                                            </div>
                                        </div>
                                        {verified && (
                                            <span className="badge bg-success-subtle text-success font-size-11 px-2.5 py-1.5 d-inline-flex align-items-center gap-1">
                                                <i className="mdi mdi-check-circle-outline font-size-13"></i>
                                                <span>Verified</span>
                                            </span>
                                        )}
                                    </div>

                                    <div className="card-body p-4">
                                        {!verified && !showForgot && !isForgotFlow && (
                                            <>
                                                <form onSubmit={(e) => {
                                                    e.preventDefault();
                                                    verifyOldPassword();
                                                    setIsForgotFlow(false);
                                                }}>
                                                    <div className="mb-3">
                                                        <label className="form-label fw-semibold font-size-13 text-secondary mb-1.5">
                                                            Old Trading Password
                                                        </label>
                                                        <div className="input-group">
                                                            <span className="input-group-text bg-light text-muted border-end-0">
                                                                <i className="mdi mdi-lock-outline font-size-16"></i>
                                                            </span>
                                                            <input
                                                                type={showMasterPass ? "text" : "password"}
                                                                className={`form-control border-start-0 border-end-0 ${passvalidations.old_password && verror ? "is-invalid" : ""}`}
                                                                name="old_password"
                                                                placeholder="Enter Old Trading Password"
                                                                value={pass.old_password}
                                                                onChange={passhandelchange}
                                                                style={{ height: "42px", fontSize: "14px" }}
                                                            />
                                                            <button
                                                                className="btn btn-light border border-start-0 text-muted"
                                                                type="button"
                                                                onClick={() => setShowMasterPass(!showMasterPass)}
                                                                style={{ padding: "0 14px" }}
                                                            >
                                                                <i className={showMasterPass ? "mdi mdi-eye-outline font-size-16" : "mdi mdi-eye-off-outline font-size-16"}></i>
                                                            </button>
                                                        </div>
                                                        {passvalidations.old_password && verror && (
                                                            <div className="text-danger font-size-12 mt-1.5 d-flex align-items-center gap-1">
                                                                <i className="mdi mdi-alert-circle-outline"></i>
                                                                <span>{verror}</span>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="pt-2">
                                                        <button
                                                            type="submit"
                                                            className="btn btn-primary waves-effect waves-light px-4 py-2 font-size-14 fw-semibold d-inline-flex align-items-center justify-content-center gap-2 shadow-sm"
                                                            style={{ borderRadius: "8px", minWidth: "150px", height: "42px" }}
                                                            disabled={loading}
                                                        >
                                                            {loading ? (
                                                                <>
                                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                    <span>Verifying...</span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="mdi mdi-shield-check-outline font-size-16"></i>
                                                                    <span>Verify</span>
                                                                </>
                                                            )}
                                                        </button>
                                                    </div>
                                                </form>

                                                <div className="mt-4 pt-3 border-top">
                                                    <button
                                                        type="button"
                                                        className="btn btn-link p-0 text-primary text-decoration-none font-size-13 fw-semibold d-inline-flex align-items-center gap-1"
                                                        onClick={() => setShowForgot(true)}
                                                    >
                                                        <i className="mdi mdi-help-circle-outline font-size-15"></i>
                                                        <span>Forgot Trading Password?</span>
                                                    </button>
                                                </div>
                                            </>
                                        )}

                                        {showForgot && (
                                            <div>
                                                <form onSubmit={submitForgotPassword}>
                                                    <div className="mb-3">
                                                        <label className="form-label fw-semibold font-size-13 text-secondary mb-1.5">
                                                            Email Address
                                                        </label>
                                                        <div className="input-group">
                                                            <span className="input-group-text bg-light text-muted border-end-0">
                                                                <i className="mdi mdi-email-outline font-size-16"></i>
                                                            </span>
                                                            <input
                                                                type="email"
                                                                className={`form-control border-start-0 ${fpValidation && fpError ? "is-invalid" : ""}`}
                                                                name="email"
                                                                placeholder="Enter your registered email"
                                                                autoComplete="off"
                                                                value={fpInput.email}
                                                                onChange={(e) => {
                                                                    setFpInput({ email: e.target.value });
                                                                    setFpValidation(false);
                                                                    setFpError("");
                                                                }}
                                                                style={{ height: "42px", fontSize: "14px" }}
                                                            />
                                                        </div>
                                                        {fpValidation && fpError && (
                                                            <div className="text-danger font-size-12 mt-1.5 d-flex align-items-center gap-1">
                                                                <i className="mdi mdi-alert-circle-outline"></i>
                                                                <span>{fpError}</span>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="d-flex align-items-center gap-2 pt-2">
                                                        <button
                                                            className="btn btn-primary waves-effect waves-light px-4 py-2 font-size-14 fw-semibold d-inline-flex align-items-center justify-content-center gap-2 shadow-sm"
                                                            style={{ borderRadius: "8px", minWidth: "140px", height: "42px" }}
                                                            type="submit"
                                                            disabled={loading}
                                                        >
                                                            {loading ? (
                                                                <>
                                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                    <span>Sending...</span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="mdi mdi-send-outline font-size-15"></i>
                                                                    <span>Send OTP</span>
                                                                </>
                                                            )}
                                                        </button>

                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-secondary waves-effect px-3 py-2 font-size-14 fw-semibold"
                                                            style={{ borderRadius: "8px", height: "42px" }}
                                                            onClick={() => {
                                                                setShowForgot(false);
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        )}

                                        {verified && (
                                            <>
                                                <form onSubmit={ChangePassword}>
                                                    <div className="alert alert-success d-flex align-items-center gap-2 py-2 px-3 mb-3 font-size-13 rounded-3" role="alert">
                                                        <i className="mdi mdi-check-circle-outline font-size-18"></i>
                                                        <div>Password verified! Please set your new trading password below.</div>
                                                    </div>

                                                    <div className="mb-3">
                                                        <label className="form-label fw-semibold font-size-13 text-secondary mb-1.5">New Password</label>
                                                        <div className="input-group">
                                                            <span className="input-group-text bg-light text-muted border-end-0">
                                                                <i className="mdi mdi-key-variant font-size-16"></i>
                                                            </span>
                                                            <input
                                                                type={showPass.new_password ? "text" : "password"}
                                                                className={`form-control border-start-0 border-end-0 ${passvalidations.new_password && verror ? "is-invalid" : ""}`}
                                                                name="new_password"
                                                                placeholder="Enter New Password"
                                                                value={pass.new_password}
                                                                onChange={passhandelchange}
                                                                style={{ height: "42px", fontSize: "14px" }}
                                                            />
                                                            <button
                                                                className="btn btn-light border border-start-0 text-muted"
                                                                type="button"
                                                                onClick={() =>
                                                                    setShowPass({ ...showPass, new_password: !showPass.new_password })
                                                                }
                                                                style={{ padding: "0 14px" }}
                                                            >
                                                                <i className={showPass.new_password ? "mdi mdi-eye-outline font-size-16" : "mdi mdi-eye-off-outline font-size-16"}></i>
                                                            </button>
                                                        </div>
                                                        {passvalidations.new_password && verror && (
                                                            <div className="text-danger font-size-12 mt-1.5 d-flex align-items-center gap-1">
                                                                <i className="mdi mdi-alert-circle-outline"></i>
                                                                <span>{verror}</span>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="mb-3">
                                                        <label className="form-label fw-semibold font-size-13 text-secondary mb-1.5">Confirm Password</label>
                                                        <div className="input-group">
                                                            <span className="input-group-text bg-light text-muted border-end-0">
                                                                <i className="mdi mdi-lock-check-outline font-size-16"></i>
                                                            </span>
                                                            <input
                                                                type={showPass.confirm_password ? "text" : "password"}
                                                                className={`form-control border-start-0 border-end-0 ${passvalidations.conform_password && verror ? "is-invalid" : ""}`}
                                                                name="conform_password"
                                                                placeholder="Confirm New Password"
                                                                value={pass.conform_password}
                                                                onChange={passhandelchange}
                                                                style={{ height: "42px", fontSize: "14px" }}
                                                            />
                                                            <button
                                                                className="btn btn-light border border-start-0 text-muted"
                                                                type="button"
                                                                onClick={() => setShowPass({ ...showPass, confirm_password: !showPass.confirm_password })}
                                                                style={{ padding: "0 14px" }}
                                                            >
                                                                <i className={showPass.confirm_password ? "mdi mdi-eye-outline font-size-16" : "mdi mdi-eye-off-outline font-size-16"}></i>
                                                            </button>
                                                        </div>
                                                        {passvalidations.conform_password && verror && (
                                                            <div className="text-danger font-size-12 mt-1.5 d-flex align-items-center gap-1">
                                                                <i className="mdi mdi-alert-circle-outline"></i>
                                                                <span>{verror}</span>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="pt-2">
                                                        <button
                                                            className="btn btn-primary waves-effect waves-light px-4 py-2 font-size-14 fw-semibold d-inline-flex align-items-center justify-content-center gap-2 shadow-sm"
                                                            style={{ borderRadius: "8px", minWidth: "160px", height: "42px" }}
                                                            type="submit"
                                                            disabled={loading}
                                                        >
                                                            {loading ? (
                                                                <>
                                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                    <span>Processing...</span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="mdi mdi-content-save-check font-size-16"></i>
                                                                    <span>Change Password</span>
                                                                </>
                                                            )}
                                                        </button>
                                                    </div>
                                                </form>
                                            </>
                                        )}

                                        {isForgotFlow && (
                                            <>
                                                <form onSubmit={ChangePassword}>
                                                    <div className="mb-3">
                                                        <label className="form-label fw-semibold font-size-13 text-secondary mb-1.5">Enter OTP</label>
                                                        <div className="input-group">
                                                            <span className="input-group-text bg-light text-muted border-end-0">
                                                                <i className="mdi mdi-numeric font-size-16"></i>
                                                            </span>
                                                            <input
                                                                type="text"
                                                                className={`form-control border-start-0 ${otpError ? "is-invalid" : ""}`}
                                                                placeholder="Enter 6-digit OTP"
                                                                value={otp}
                                                                maxLength={6}
                                                                onChange={(e) => {
                                                                    setOtp(e.target.value);
                                                                    setOtpError("");
                                                                }}
                                                                style={{ height: "42px", fontSize: "14px", letterSpacing: "2px" }}
                                                            />
                                                        </div>
                                                        {otpError && (
                                                            <div className="text-danger font-size-12 mt-1.5 d-flex align-items-center gap-1">
                                                                <i className="mdi mdi-alert-circle-outline"></i>
                                                                <span>{otpError}</span>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="mb-3">
                                                        <label className="form-label fw-semibold font-size-13 text-secondary mb-1.5">New Password</label>
                                                        <div className="input-group">
                                                            <span className="input-group-text bg-light text-muted border-end-0">
                                                                <i className="mdi mdi-key-variant font-size-16"></i>
                                                            </span>
                                                            <input
                                                                type={showPass.new_password ? "text" : "password"}
                                                                className={`form-control border-start-0 border-end-0 ${passvalidations.new_password && verror ? "is-invalid" : ""}`}
                                                                name="new_password"
                                                                placeholder="Enter New Password"
                                                                value={pass.new_password}
                                                                onChange={passhandelchange}
                                                                style={{ height: "42px", fontSize: "14px" }}
                                                            />
                                                            <button
                                                                className="btn btn-light border border-start-0 text-muted"
                                                                type="button"
                                                                onClick={() => setShowPass({ ...showPass, new_password: !showPass.new_password })}
                                                                style={{ padding: "0 14px" }}
                                                            >
                                                                <i className={showPass.new_password ? "mdi mdi-eye-outline font-size-16" : "mdi mdi-eye-off-outline font-size-16"}></i>
                                                            </button>
                                                        </div>
                                                        {passvalidations.new_password && verror && (
                                                            <div className="text-danger font-size-12 mt-1.5 d-flex align-items-center gap-1">
                                                                <i className="mdi mdi-alert-circle-outline"></i>
                                                                <span>{verror}</span>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="mb-3">
                                                        <label className="form-label fw-semibold font-size-13 text-secondary mb-1.5">Confirm Password</label>
                                                        <div className="input-group">
                                                            <span className="input-group-text bg-light text-muted border-end-0">
                                                                <i className="mdi mdi-lock-check-outline font-size-16"></i>
                                                            </span>
                                                            <input
                                                                type={showPass.confirm_password ? "text" : "password"}
                                                                className={`form-control border-start-0 border-end-0 ${passvalidations.conform_password && verror ? "is-invalid" : ""}`}
                                                                name="conform_password"
                                                                placeholder="Confirm New Password"
                                                                value={pass.conform_password}
                                                                onChange={passhandelchange}
                                                                style={{ height: "42px", fontSize: "14px" }}
                                                            />
                                                            <button
                                                                className="btn btn-light border border-start-0 text-muted"
                                                                type="button"
                                                                onClick={() => setShowPass({ ...showPass, confirm_password: !showPass.confirm_password })}
                                                                style={{ padding: "0 14px" }}
                                                            >
                                                                <i className={showPass.confirm_password ? "mdi mdi-eye-outline font-size-16" : "mdi mdi-eye-off-outline font-size-16"}></i>
                                                            </button>
                                                        </div>
                                                        {passvalidations.conform_password && verror && (
                                                            <div className="text-danger font-size-12 mt-1.5 d-flex align-items-center gap-1">
                                                                <i className="mdi mdi-alert-circle-outline"></i>
                                                                <span>{verror}</span>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="pt-2">
                                                        <button
                                                            className="btn btn-primary waves-effect waves-light px-4 py-2 font-size-14 fw-semibold d-inline-flex align-items-center justify-content-center gap-2 shadow-sm"
                                                            style={{ borderRadius: "8px", minWidth: "160px", height: "42px" }}
                                                            type="submit"
                                                            disabled={loading}
                                                        >
                                                            {loading ? (
                                                                <>
                                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                    <span>Processing...</span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="mdi mdi-content-save-check font-size-16"></i>
                                                                    <span>Change Password</span>
                                                                </>
                                                            )}
                                                        </button>
                                                    </div>
                                                </form>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}